import React from "react"; 

import '../LoadingPage/loading.scss'


const Loading: React.FC <{transparent?: boolean}> = ({transparent}) => {

	const style: React.CSSProperties = {
		backgroundColor: transparent ? 'rgba(0, 0, 0, 0)' : undefined,
		position: transparent ? 'absolute' : undefined,
		width: transparent ? '100vw' : undefined,
		height: transparent ? '100vh' : undefined,
	}

	
    return (
			<div className="loader__wrapper" style={style}>
				<div className="loader">
				</div>
			</div>
    )
}

export default Loading;